import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const navigationKitAvatarPopupContentEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "async-horizontal-nav-edit-project-avatar-popup" */ './NavigationKitAvatarPopupContent'
		).then((module) => module.NavigationKitAvatarPopupContentEntryPoint),
	),
	getPreloadProps: () => ({}),
});
